import React, { useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import ChangePasswordEnhancer from "./enhancer/ChangePasswordEnhancer";
import NavigationActions from "redux/navigation/actions";
import authActions from "redux/auth/actions";
import { Visibility } from "@mui/icons-material";
import { VisibilityOff } from "@mui/icons-material";
import Loader from "components/Loader";
import { change_password } from "services/merchantProfileServices";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const { success, error } = NavigationActions;
const { setUser } = authActions;
function ChangePassword(props) {
  const [isCurrentPwdVisible, setIsCurrentPasswordVisible] = useState(false);
  const [isNewPwdVisible, setNewPwdPasswordVisible] = useState(false);
  const [isConfirmPwdVisible, setIsConfirmPwdVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const {
    values,
    handleChange,
    handleBlur,
    errors,
    touched,
    submitCount,
    handleSubmit,
    user,
    token,
    isValid,
    resetForm
  } = props;

  const Error = props => {
    const field1 = props.field;
    if ((errors[field1] && touched[field1]) || submitCount > 0) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span />;
    }
  };
  const changePasswordHandler = async e => {
    e.preventDefault();
    handleSubmit();
    if (isValid) {
      setLoading(true);
      await change_password(token, user._id, values).then(res => {
        if (res.success) {
          success(res.message);
          resetForm();
        } else {
          error(res.message);
        }
        setLoading(false);
      });
    }
  };

  return (
    <div className="work-card">
      <h4>Change Password</h4>
      <div className="work-body mt-4">
        <form onSubmit={changePasswordHandler}>
          <div className="row login-box p-0 w-100">
            <div className="col-12 col-sm-7">
              <div className="form-group">
                <label>Current Password</label>
                <div className="input-group show-hide-password">
                  <input
                    type={isCurrentPwdVisible ? "text" : "password"}
                    className="form-control react-form-input"
                    id="current_password"
                    onChange={handleChange}
                    value={values.current_password}
                    onBlur={handleBlur}
                    placeholder="Current Password"
                  />
                  <div className="input-group-append">
                    {isCurrentPwdVisible ? (
                      <VisibilityOff
                        onClick={() => setIsCurrentPasswordVisible(false)}
                      />
                    ) : (
                      <Visibility
                        onClick={() => {
                          setIsCurrentPasswordVisible(true);
                        }}
                      />
                    )}
                  </div>
                </div>
                <Error field="current_password" />
              </div>
            </div>
            <div className="col-12 col-sm-7">
              <div className="form-group">
                <label>New Password</label>
                <div className="input-group show-hide-password">
                  <input
                    type={isNewPwdVisible ? "text" : "password"}
                    className="form-control react-form-input"
                    id="new_password"
                    onChange={handleChange}
                    value={values.new_password}
                    onBlur={handleBlur}
                    placeholder="New Password"
                  />
                  <div className="input-group-append">
                    {isNewPwdVisible ? (
                      <VisibilityOff
                        onClick={() => setNewPwdPasswordVisible(false)}
                      />
                    ) : (
                      <Visibility
                        onClick={() => {
                          setNewPwdPasswordVisible(true);
                        }}
                      />
                    )}
                  </div>
                </div>
                <Error field="new_password" />
              </div>
            </div>
            <div className="col-12 col-sm-7">
              <div className="form-group">
                <label>Confirm Password</label>
                <div className="input-group show-hide-password">
                  <input
                    type={isConfirmPwdVisible ? "text" : "password"}
                    className="form-control react-form-input"
                    id="confirm_new_password"
                    onChange={handleChange}
                    value={values.confirm_new_password}
                    onBlur={handleBlur}
                    placeholder="Confirm Password"
                  />
                  <div className="input-group-append">
                    {isConfirmPwdVisible ? (
                      <VisibilityOff
                        onClick={() => setIsConfirmPwdVisible(false)}
                      />
                    ) : (
                      <Visibility
                        onClick={() => {
                          setIsConfirmPwdVisible(true);
                        }}
                      />
                    )}
                  </div>
                </div>
                <Error field="confirm_new_password" />
              </div>
            </div>
            <div className="col-12 col-sm-7 text-right">
              <button
                type="submit"
                className="btn btn-info px-5"
                onClick={e => {
                  changePasswordHandler(e);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
      {loading && <Loader />}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user
  };
};

export default compose(
  withRouter,
  ChangePasswordEnhancer,
  connect(mapStateToProps, { success, error, setUser })
)(ChangePassword);
